var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-shadow",attrs:{"id":"sidebar-container"}},[_c('div',{staticClass:"sidebar-content"},[_c('nav',[_c('v-btn',{staticClass:"navbar-button",attrs:{"icon":"","dark":"","xLarge":""},on:{"click":function($event){return _vm.toggleSidebar()}}},[_c('v-icon',[_vm._v(" mdi-menu ")])],1)],1),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }